import request from '@/utils/request';
import gatewayPrefix from '@comp/utils/gatewayPrefix.js';
/**
 * 订单详情
 */
export const orderDetailApi = (data) => {
  return request({
    url: '/order/client/order/detail',
    data,
    method: 'post',
  });
};

/**
 * 秒杀结果接口
 */
export const getActivityResultApi = (params) => {
  return request({
    url: '/order/client/order/activity/result',
    params,
    method: 'get',
  });
};

/**
 * 获取支付方式
 */
export const getPayMode = (data, payMethod = ['CHN_PAY', 'INTL_PAY']) => {
  data = Object.assign({ applyPort: 'PC', enterpriseId: localStorage.enterpriseid }, data);
  return new Promise(async (resolve, reject) => {
    const CHN_PAY = () =>
      request({
        url: '/order/pay/methods',
        data: { ...data, payMethod: 'CHN_PAY' },
        method: 'post',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        res.data = res.data.filter((item) => item.channelType === 'CHN_PAY');
        return res;
      });

    const INTL_PAY = () =>
      request({
        url: '/order/pay/methods',
        data: { ...data, payMethod: 'INTL_PAY' },
        method: 'post',
        headers: {
          'Content-Type': 'application/json;charset=UTF-8',
        },
      }).then((res) => {
        res.data = res.data.filter((item) => item.channelType === 'INTL_PAY');
        return res;
      });

    const isCHN_PAY = payMethod.includes('CHN_PAY');
    const isINTL_PAY = payMethod.includes('INTL_PAY');
    const req = [];
    isCHN_PAY && req.push(CHN_PAY());
    isINTL_PAY && req.push(INTL_PAY());
    const res = await Promise.all(req).catch(() => reject());

    if (isINTL_PAY && isCHN_PAY) {
      res[0].data = [...res[0].data, ...res[1].data];
    }
    resolve(res[0]);
  });
};

export const getPfCompanyAllPayMethods = () => {
  return request({
    url: '/order/pay/getPfCompanyAllPayMethods',
    data: { applyPort: 'PC' },
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 * 获取税率接口
 */
export const invoiceTaxRateApi = (data) => {
  return request({
    url: '/order/client/invoiceTaxRate/list',
    data,
    method: 'post',
  });
};

/**
 * 优惠券计算金额
 */
export const getDiscountAmount = (data) => {
  return request({
    url: '/marketingcenter/management/coupon/discountAmount/calc',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 * 单个商品下单
 */
export const createOrderApi = (data) => {
  return request({
    url: '/order/client/order/create',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};
/**
 * 活动商品下单
 */
export const activityCreateApi = (data) => {
  return request({
    url: '/order/client/order/pc/activity/create',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 * 订单可使用的优惠卷列表
 */
export const applyCoupponList = (data) => {
  return request({
    url: '/marketingcenter/client/coupon/applyList',
    method: 'post',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 * 支付
 */
export const toPay = (data) => {
  return request({
    url: '/order/pay/toPay',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 * 缓存中获取国家数据
 */
export const getCacheCountryListApi = () => {
  return request({
    url: '/order/management/country/countryList',
    method: 'post',
  });
};

/**
 * 修改用户购物车商品数量
 */
export const modifyShoppingCartNumber = (data) => {
  return request({
    url: '/order/client/cart/updateCount',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 * 用户购物车商品数量
 */

export const totalShoppingCart = (data) => {
  return request({
    url: '/order/client/cart/count',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 * 删除用户购物车商品
 */
export const deleteCartItems = (data) => {
  return request({
    url: '/order/client/cart/delete',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 * 分页获取用户购物车商品列表
 */
export const getListItems = () => {
  return request({
    url: '/order/client/cart/list',
    method: 'get',
  });
};

/**
 * 续费管理的支付下单
 */
export const renewalPay = (data) => {
  return request({
    url: '/order/client/order/renewal',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 * 优惠券-列表分页(客户端)
 */
export const coupponList = (data) => {
  return request({
    url: '/marketingcenter/client/coupon/list',
    method: 'POST',
    data,
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 *  订单收银台详情
 */
export const queryUserTransferAccountInfo = (params) => {
  return request({
    url: '/order/pay/queryUserTransferAccountInfo?userId=' + `${params}&enterpriseId=42`,
    method: 'get',
  });
};

/**渠道购物车接口 */
export const getChannelListItems = () => {
  return request({
    url: '/order/client/cart/channel/list',
    method: 'get',
  });
};

/**
 *  周期结算 支付
 */
export const cycleToPay = (data) => {
  return request({
    url: '/order/client/pay/channel/toPay',
    data,
    method: 'post',
  });
};

/**
 *  根据币种汇率计算金额
 */
export const rateCalculateAmount = (data) => {
  return request({
    url: '/order/pay/exchange/rate',
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

/**
 *  根据币种汇率计算金额
 */
export const getPayresultStatus = (orderNo) => {
  return request({
    url: `/order/pay/result_status/${orderNo}`,
    method: 'get',
  });
};

/**
 *  上传续费下单选择的产品信息
 */
export const uploadEprWorkProduct = (data) => {
  return request({
    url: `/${gatewayPrefix.workorder}/client/epr/renew/uploadEprWorkProduct`,
    data,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
  });
};

//新获取商品列表接口
export const newProductInfo = (params) => {
  return request({
    url: '/productcenter/client/productInfo/list',
    data: params,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
    },
  });
};



// WEBPACK FOOTER //
// ./xcloud-client-components-web/api/shoppingCar/index.js